import { render, staticRenderFns } from "./TimeAndAgo.vue?vue&type=template&id=ade7a440&scoped=true&"
import script from "./TimeAndAgo.vue?vue&type=script&lang=js&"
export * from "./TimeAndAgo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade7a440",
  null
  
)

export default component.exports